import * as React from 'react';

export const VideoViewer = ({ src, playNext, startPlay }: GifViewerProps) => {
  const ref = React.useRef<HTMLVideoElement>(null);

  React.useEffect(() => {
    if (!ref.current) {
      throw new Error('Video ref is not defined.');
    }

    if (startPlay) {
      ref.current.currentTime = 0;
      ref.current.play();
    } else {
      ref.current.pause();
    }
  }, [startPlay]);

  return (
    <video
      className='w-full'
      controls={false}
      ref={ref}
      muted
      preload='true'
      src={src}
      onEnded={playNext}
    />
  );
};

type GifViewerProps = {
  src: string;
  startPlay: boolean;
  playNext: () => void;
};
